/**
 * LANNA STUDIO - Custom Package Builder Logic & Dynamic Slots
 * Fully Atomic Cart Synchronization & Serialized Queue Architecture
 */
(function() {
  function initCustomPackageBuilder() {
    var sectionEl = document.querySelector('.custom-package-builder');
    if (!sectionEl || sectionEl.dataset.initialized === 'true') return;
    sectionEl.dataset.initialized = 'true';

    var bundleItems = []; // Array of { productId, variantId, title, price, image }
    var selectedShipping = 'standard'; // 'standard' or 'express'

    // Synchronization Mutex & State
    var isSyncing = false;
    var syncPending = false;
    var syncDebounceTimer = null;

    var slotsGrid = document.getElementById('BundleSlotsGrid');
    var slotsCounter = document.getElementById('BundleSlotsCounter');
    var milestoneAlert = document.getElementById('BundleMilestoneAlert');
    var alertText = document.getElementById('BundleAlertText');
    var shippingSelector = document.getElementById('BundleShippingSelector');
    
    var subtotalAmount = document.getElementById('BundleSubtotalAmount');
    var subtotalLabel = document.getElementById('BundleSubtotalLabel');
    var regularPriceRow = document.getElementById('BundleRegularPriceRow');
    var regularPriceAmount = document.getElementById('BundleRegularPriceAmount');
    var discountRow = document.getElementById('BundleDiscountRow');
    var discountLabel = document.getElementById('BundleDiscountLabel');
    var discountAmount = document.getElementById('BundleDiscountAmount');
    var shippingLabel = document.getElementById('BundleShippingLabel');
    var totalAmount = document.getElementById('BundleTotalAmount');
    
    var submitBtn = document.getElementById('BundleSubmitButton');
    var submitLabel = document.getElementById('BundleSubmitLabel');

    // Toast Notification Elements & Logic
    var toastEl = document.getElementById('BundleFloatingToast');
    var toastBadge = document.getElementById('BundleToastBadge');
    var toastMessage = document.getElementById('BundleToastMessage');
    var toastTimer = null;

    if (toastEl && toastEl.parentElement !== document.body) {
      document.body.appendChild(toastEl);
    }

    function triggerToast(count) {
      if (!toastEl) toastEl = document.getElementById('BundleFloatingToast');
      if (!toastBadge) toastBadge = document.getElementById('BundleToastBadge');
      if (!toastMessage) toastMessage = document.getElementById('BundleToastMessage');
      if (!toastEl || !toastBadge || !toastMessage) return;

      if (toastEl.parentElement !== document.body) {
        document.body.appendChild(toastEl);
      }

      var badgeText = count + '/4';
      var msgText = '';

      if (count === 0) {
        badgeText = '0/4';
        msgText = 'Select cups from the catalog to build your set';
      } else if (count === 1) {
        badgeText = '1/4';
        msgText = '$5 Shipping • Add 1 more for Free Shipping!';
      } else if (count === 2) {
        badgeText = '2/4';
        msgText = 'Free Shipping Unlocked! Add 1 more for 10% OFF';
      } else if (count === 3) {
        badgeText = '3/4';
        msgText = '10% OFF + Free Shipping! Add 1 more for 15% OFF';
      } else {
        badgeText = (count >= 4 ? count : 4) + '/4';
        msgText = '15% OFF + Free Shipping Unlocked!';
      }

      toastBadge.textContent = badgeText;
      toastMessage.textContent = msgText;

      if (toastTimer) clearTimeout(toastTimer);
      toastEl.classList.add('is-visible');

      toastTimer = setTimeout(function() {
        if (toastEl) toastEl.classList.remove('is-visible');
      }, 4000);
    }

    function formatMoney(cents) {
      var format = window.themeCurrencyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      return format
        .replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    // Helper: Collect all variant IDs in this builder collection
    function getKnownVariantIds() {
      var ids = [];
      sectionEl.querySelectorAll('.bundle-artisan-card').forEach(function(card) {
        if (card.dataset.variantId) {
          ids.push(String(card.dataset.variantId));
        }
      });
      return ids;
    }

    // Helper: Desired target quantity per variant from bundleItems
    function getTargetBundleCounts() {
      var counts = {};
      bundleItems.forEach(function(it) {
        var vid = String(it.variantId);
        counts[vid] = (counts[vid] || 0) + 1;
      });
      return counts;
    }

    function renderBuilder() {
      var count = bundleItems.length;
      var rawSubtotal = bundleItems.reduce(function(acc, item) { return acc + item.price; }, 0);
      
      // Calculate Discount & Shipping matching the exact 4-tier engine:
      // 0 Cups: 0% discount, $0 shipping
      // 1 Cup:  0% discount, $5.00 flat shipping
      // 2 Cups: 0% discount, FREE shipping
      // 3 Cups: 10% discount, FREE shipping
      // 4+ Cups: 15% discount, FREE shipping
      var discountPercent = 0;
      if (count >= 4) {
        discountPercent = 15;
      } else if (count === 3) {
        discountPercent = 10;
      }

      var discountCents = Math.round(rawSubtotal * (discountPercent / 100));
      var shippingFeeCents = 0;
      if (count === 1) {
        shippingFeeCents = 500; // $5.00 Flat Shipping
      } else {
        shippingFeeCents = 0; // FREE for 2+, $0 for 0
      }
      var finalTotal = (rawSubtotal - discountCents) + shippingFeeCents;

      // 1. Progress Tracker (Top Gauge)
      var progressBarFill = document.getElementById('BundleProgressBarFill');
      var progressSteps = sectionEl.querySelectorAll('.bundle-progress__step');
      
      if (progressBarFill) {
        var progressPercent = 0;
        if (count === 1) progressPercent = 25;
        else if (count === 2) progressPercent = 50;
        else if (count === 3) progressPercent = 75;
        else if (count >= 4) progressPercent = 100;

        progressBarFill.style.width = progressPercent + '%';
        if (count >= 4) {
          progressBarFill.classList.add('is-unlocked');
        } else {
          progressBarFill.classList.remove('is-unlocked');
        }
      }

      if (progressSteps && progressSteps.length > 0) {
        progressSteps.forEach(function(stepEl, idx) {
          var stepNum = idx + 1;
          stepEl.classList.remove('active', 'unlocked');
          if (count >= 4 && stepNum === 4) {
            stepEl.classList.add('unlocked');
          } else if (count >= stepNum) {
            stepEl.classList.add('active');
          }
        });
      }

      // 2. Dynamic Customer Alert Pill
      var alertIcon = document.getElementById('BundleAlertIcon');
      if (milestoneAlert && alertText) {
        if (count === 0) {
          milestoneAlert.className = 'bundle-progress__alert';
          if (alertIcon) {
            alertIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
          }
          alertText.textContent = 'Select cups from the catalog to start building your set';
        } else if (count === 1) {
          milestoneAlert.className = 'bundle-progress__alert';
          if (alertIcon) {
            alertIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
          }
          alertText.textContent = 'Add 1 more cup to unlock Free Shipping';
        } else if (count === 2) {
          milestoneAlert.className = 'bundle-progress__alert is-unlocked';
          if (alertIcon) {
            alertIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
          }
          alertText.textContent = '✓ Free Shipping Unlocked! Add 1 more cup for 10% OFF';
        } else if (count === 3) {
          milestoneAlert.className = 'bundle-progress__alert is-unlocked';
          if (alertIcon) {
            alertIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
          }
          alertText.textContent = '✓ 10% OFF + Free Shipping Unlocked! Add 1 more cup for 15% OFF';
        } else {
          milestoneAlert.className = 'bundle-progress__alert is-unlocked';
          if (alertIcon) {
            alertIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
          }
          alertText.textContent = '✓ Maximum Tier Unlocked: 15% OFF + Free Shipping!';
        }
      }

      // 3. Dynamic Expanding Square Slot Architecture
      if (slotsGrid) {
        slotsGrid.innerHTML = '';
        var totalSlots = Math.max(4, count + 1);

        for (var i = 0; i < totalSlots; i++) {
          var item = bundleItems[i];
          var slotEl = document.createElement('div');

          if (item) {
            slotEl.className = 'bundle-slot-square bundle-slot-square--filled';
            slotEl.innerHTML = 
              '<img src="' + (item.image || '') + '" alt="' + (item.title || '') + '" class="bundle-slot-square__img">' +
              '<button type="button" class="bundle-slot-square__remove" data-remove-index="' + i + '" aria-label="Remove ' + (item.title || 'cup') + '" title="Remove cup">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
              '</button>' +
              '<span class="bundle-slot-square__label">' + (item.title || 'Cup') + '</span>';
          } else {
            slotEl.className = 'bundle-slot-square bundle-slot-square--empty';
            slotEl.innerHTML = 
              '<span class="bundle-slot-square__plus">+</span>' +
              '<span class="bundle-slot-square__text">SLOT ' + (i + 1) + '</span>';
          }

          slotsGrid.appendChild(slotEl);
        }
      }

      // 4. Price Breakdown Display
      if (subtotalLabel) subtotalLabel.textContent = 'Subtotal (' + count + ' item' + (count === 1 ? '' : 's') + ')';
      if (subtotalAmount) {
        if (discountPercent > 0) {
          subtotalAmount.innerHTML = '<s style="opacity:0.5; margin-right:6px;">' + formatMoney(rawSubtotal) + '</s>' + formatMoney(rawSubtotal - discountCents);
        } else {
          subtotalAmount.textContent = formatMoney(rawSubtotal);
        }
      }

      if (discountRow && discountAmount) {
        if (discountPercent > 0) {
          discountRow.style.display = 'flex';
          if (discountLabel) {
            discountLabel.textContent = 'Bundle Savings (' + discountPercent + '% OFF)';
          }
          discountAmount.textContent = '-' + formatMoney(discountCents);
          discountAmount.style.color = '#2D5A27';
          discountAmount.style.fontWeight = '600';
        } else {
          discountRow.style.display = 'none';
        }
      }

      if (shippingLabel) {
        if (count >= 2) {
          shippingLabel.textContent = 'FREE';
          shippingLabel.style.color = '#2D5A27';
          shippingLabel.style.fontWeight = '600';
        } else if (count === 1) {
          shippingLabel.textContent = '$5.00';
          shippingLabel.style.color = '#A86538';
          shippingLabel.style.fontWeight = '600';
        } else {
          shippingLabel.textContent = '$0.00';
          shippingLabel.style.color = '#78716C';
          shippingLabel.style.fontWeight = '500';
        }
      }

      if (totalAmount) {
        totalAmount.textContent = formatMoney(finalTotal);
      }

      // 5. Primary CTA State (Disabled at 0 cups, Active at 1+ cups)
      if (submitBtn && submitLabel) {
        if (count === 0) {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.classList.remove('is-active');
          submitLabel.textContent = 'SELECT CUPS TO BEGIN';
        } else if (count === 1) {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.add('is-active');
          submitLabel.textContent = 'ADD 1 MORE FOR FREE SHIPPING (1/2) — ' + formatMoney(finalTotal) + ' →';
        } else if (count === 2) {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.add('is-active');
          submitLabel.textContent = 'PROCEED TO CHECKOUT — ' + formatMoney(finalTotal) + ' →';
        } else if (count === 3) {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.add('is-active');
          submitLabel.textContent = 'PROCEED TO CHECKOUT — ' + formatMoney(finalTotal) + ' (10% OFF) →';
        } else {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.add('is-active');
          submitLabel.textContent = 'PROCEED TO CHECKOUT — ' + formatMoney(finalTotal) + ' (15% OFF) →';
        }
      }

      // 6. Update Product Card Badges
      var countsByVariant = getTargetBundleCounts();

      sectionEl.querySelectorAll('.bundle-artisan-card').forEach(function(card) {
        var vId = card.dataset.variantId ? String(card.dataset.variantId) : '';
        var pCount = vId ? (countsByVariant[vId] || 0) : 0;
        var badge = card.querySelector('[data-badge-count]');
        if (pCount > 0) {
          card.classList.add('has-items');
          if (badge) badge.textContent = pCount;
        } else {
          card.classList.remove('has-items');
          if (badge) badge.textContent = '0';
        }
      });
    }

    // Helper: Update Header Cart Bubble
    function updateHeaderBubble(itemCount) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;

      var countEl = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      var countContainer = bubble.querySelector('.cart-count-bubble');

      if (itemCount > 0) {
        if (countEl) {
          countEl.textContent = itemCount;
        } else if (countContainer) {
          countContainer.innerHTML = '<span aria-hidden="true">' + itemCount + '</span><span class="visually-hidden">Cart count: ' + itemCount + '</span>';
        } else {
          bubble.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true">' + itemCount + '</span></div>');
        }
      } else {
        if (countContainer) countContainer.remove();
      }

      // Fetch fresh server HTML to ensure icons and accessibility tags match exactly
      fetch('/?section_id=cart-icon-bubble', { credentials: 'same-origin' })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newBubble = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
          if (newBubble && bubble) {
            bubble.innerHTML = newBubble.innerHTML;
          }
        })
        .catch(function() {});
    }

    // Central Reconciler: Synchronizes local bundleItems state atomically to Shopify Cart
    function reconcileCartWithShopify() {
      var knownIds = getKnownVariantIds();
      var targetCounts = getTargetBundleCounts();

      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart fetch failed with status ' + res.status);
        return res.json();
      })
      .then(function(cart) {
        var cartLinesByVariant = {};
        var nonBundleCount = 0;

        (cart.items || []).forEach(function(item) {
          var vid = String(item.variant_id || item.id);
          if (knownIds.indexOf(vid) !== -1) {
            if (!cartLinesByVariant[vid]) cartLinesByVariant[vid] = [];
            cartLinesByVariant[vid].push(item);
          } else {
            nonBundleCount += item.quantity;
          }
        });

        var updates = {};
        var itemsToAdd = [];

        knownIds.forEach(function(vid) {
          var targetQty = targetCounts[vid] || 0;
          var lines = cartLinesByVariant[vid] || [];
          var currentTotalQty = lines.reduce(function(sum, l) { return sum + l.quantity; }, 0);

          if (lines.length === 0) {
            if (targetQty > 0) {
              itemsToAdd.push({ id: parseInt(vid, 10), quantity: targetQty });
            }
          } else {
            if (currentTotalQty !== targetQty || lines.length > 1) {
              lines.forEach(function(line, idx) {
                updates[line.key] = idx === 0 ? targetQty : 0;
              });
            }
          }
        });

        var hasUpdates = Object.keys(updates).length > 0;
        var hasAdds = itemsToAdd.length > 0;

        var chain = Promise.resolve();

        if (hasUpdates) {
          chain = chain.then(function() {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              credentials: 'same-origin',
              body: JSON.stringify({ updates: updates })
            });
          });
        }

        if (hasAdds) {
          chain = chain.then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              credentials: 'same-origin',
              body: JSON.stringify({ items: itemsToAdd })
            });
          });
        }

        return chain.then(function() {
          if (hasUpdates || hasAdds) {
            var cartPromise = fetch('/cart.js', {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin'
            }).then(function(r) { return r.json(); });

            var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            var sectionsUrl = rootUrl + (rootUrl.endsWith('/') ? '' : '/') + '?sections=cart-drawer,cart-icon-bubble';
            var sectionsPromise = fetch(sectionsUrl, {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin'
            }).then(function(r) { return r.json(); }).catch(function() { return null; });

            return Promise.all([cartPromise, sectionsPromise]).then(function(results) {
              return { cart: results[0], sections: results[1] };
            });
          }
          return { cart: cart, sections: null };
        });
      })
      .then(function(result) {
        var finalCart = result.cart;
        var sectionsData = result.sections;

        updateHeaderBubble(finalCart.item_count);

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (sectionsData && (sectionsData['cart-drawer'] || (sectionsData.sections && sectionsData.sections['cart-drawer']))) {
            var payload = sectionsData.sections ? sectionsData : { sections: sectionsData };
            payload.item_count = finalCart.item_count;
            payload.total_price = finalCart.total_price;
            payload.original_total_price = finalCart.original_total_price;
            payload.total_discount = finalCart.total_discount;
            payload.items = finalCart.items;
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(payload, false);
            }
          } else {
            if (typeof cartDrawer.updateProgressBar === 'function') {
              cartDrawer.updateProgressBar(finalCart.item_count);
            }
            if (typeof cartDrawer.updateFromCartPayload === 'function') {
              cartDrawer.updateFromCartPayload(finalCart);
            }
          }
        }

        if (typeof window.syncAllCardPillsFromCart === 'function') {
          window.syncAllCardPillsFromCart();
        }

        document.dispatchEvent(new CustomEvent('bundle:cart-updated', { detail: finalCart }));
        return finalCart;
      });
    }

    // Serialized Queue Manager to avoid parallel cart mutation race conditions
    function runCartSyncQueue() {
      if (isSyncing) {
        syncPending = true;
        return;
      }
      isSyncing = true;
      syncPending = false;

      reconcileCartWithShopify()
        .then(function(updatedCart) {
          isSyncing = false;
          if (syncPending) {
            runCartSyncQueue();
          } else {
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-package-builder', cartData: updatedCart });
            }
          }
        })
        .catch(function(err) {
          console.error('Cart sync error:', err);
          isSyncing = false;
          if (syncPending) {
            runCartSyncQueue();
          }
        });
    }

    function triggerCartSync(immediate) {
      if (syncDebounceTimer) clearTimeout(syncDebounceTimer);
      if (immediate) {
        runCartSyncQueue();
      } else {
        syncDebounceTimer = setTimeout(runCartSyncQueue, 250);
      }
    }

    // Initial Load & External Sync from Shopify Cart
    function syncFromCart(showToastIfChanged) {
      if (isSyncing || syncPending) return Promise.resolve();

      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
      .then(function(res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function(cart) {
        if (isSyncing || syncPending) return;
        if (!cart || !Array.isArray(cart.items)) return;

        var prevCount = bundleItems.length;
        var newBundleItems = [];

        var availableCards = {};
        sectionEl.querySelectorAll('.bundle-artisan-card').forEach(function(card) {
          if (card.dataset.productId) availableCards['p_' + card.dataset.productId] = card;
          if (card.dataset.variantId) availableCards['v_' + card.dataset.variantId] = card;
        });

        cart.items.forEach(function(item) {
          var pKey = 'p_' + item.product_id;
          var vKey = 'v_' + item.variant_id;
          var matchedCard = availableCards[vKey] || availableCards[pKey];

          // Only sync items that belong to the builder collection
          if (!matchedCard) return;

          var itemTitle = matchedCard.dataset.title;
          var itemPrice = parseInt(matchedCard.dataset.price, 10);
          var itemImage = matchedCard.dataset.image;

          for (var q = 0; q < item.quantity; q++) {
            newBundleItems.push({
              productId: String(item.product_id),
              variantId: item.variant_id,
              title: itemTitle,
              price: itemPrice,
              image: itemImage
            });
          }
        });

        bundleItems = newBundleItems;
        renderBuilder();

        if (showToastIfChanged && bundleItems.length > 0 && bundleItems.length !== prevCount) {
          triggerToast(bundleItems.length);
        }
      })
      .catch(function(err) {
        console.error('Error syncing bundle builder from cart:', err);
      });
    }

    // Section Click Listeners
    sectionEl.addEventListener('click', function (e) {
      // 0a. Stepper Plus in Curated List
      var stepperPlus = e.target.closest('[data-action="stepper-plus"]');
      if (stepperPlus) {
        e.preventDefault();
        e.stopPropagation();
        var vId = stepperPlus.dataset.variantId;
        var existing = bundleItems.find(function(it) { return String(it.variantId) === String(vId); });
        if (existing) {
          bundleItems.push(Object.assign({}, existing));
          renderBuilder();
          triggerToast(bundleItems.length);
          triggerCartSync(false);
        }
        return;
      }

      // 0b. Stepper Minus in Curated List
      var stepperMinus = e.target.closest('[data-action="stepper-minus"]');
      if (stepperMinus) {
        e.preventDefault();
        e.stopPropagation();
        var vId = stepperMinus.dataset.variantId;
        var removeIdx = -1;
        for (var i = bundleItems.length - 1; i >= 0; i--) {
          if (String(bundleItems[i].variantId) === String(vId)) {
            removeIdx = i;
            break;
          }
        }
        if (removeIdx > -1) {
          bundleItems.splice(removeIdx, 1);
          renderBuilder();
          triggerToast(bundleItems.length);
          triggerCartSync(false);
        }
        return;
      }

      // 0c. Remove Group (all quantities of that cup)
      var removeGroup = e.target.closest('[data-action="remove-group"]');
      if (removeGroup) {
        e.preventDefault();
        e.stopPropagation();
        var vId = removeGroup.dataset.variantId;
        bundleItems = bundleItems.filter(function(it) { return String(it.variantId) !== String(vId); });
        renderBuilder();
        triggerToast(bundleItems.length);
        triggerCartSync(false);
        return;
      }

      // 1. Remove item from slot square
      var removeBtn = e.target.closest('[data-remove-index]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(removeBtn.dataset.removeIndex, 10);
        if (!isNaN(idx) && idx >= 0 && idx < bundleItems.length) {
          bundleItems.splice(idx, 1);
          renderBuilder();
          triggerToast(bundleItems.length);
          triggerCartSync(false);
        }
        return;
      }

      // 2. Add product to bundle click listener
      var addBtn = e.target.closest('[data-action="add-to-bundle"]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        var card = addBtn.closest('.bundle-artisan-card');
        if (!card) return;

        var newItem = {
          productId: card.dataset.productId,
          variantId: parseInt(card.dataset.variantId, 10),
          title: card.dataset.title,
          price: parseInt(card.dataset.price, 10),
          image: card.dataset.image
        };

        bundleItems.push(newItem);
        renderBuilder();
        triggerToast(bundleItems.length);

        // Tactile button feedback
        addBtn.classList.add('loading');
        setTimeout(function() {
          addBtn.classList.remove('loading');
          addBtn.classList.add('is-success');
          setTimeout(function() {
            addBtn.classList.remove('is-success');
          }, 1200);
        }, 150);

        triggerCartSync(false);
        return;
      }

      // 3. Quick View modal trigger when clicking card body
      var card = e.target.closest('.bundle-artisan-card');
      if (card) {
        if (e.target.closest('quick-add-modal') || e.target.closest('.quick-add-modal__toggle') || e.target.closest('.bundle-card-add-wrapper') || e.target.closest('.card-quick-add-wrapper') || e.target.closest('button')) return;
        var mediaWrap = card.querySelector('.bundle-artisan-card__media-wrap');
        if (mediaWrap) {
          var rect = mediaWrap.getBoundingClientRect();
          var clickY = e.clientY - rect.top;
          if (clickY > (rect.height * 0.72) || clickY > (rect.height - 72)) {
            return;
          }
        }
        var openerBtn = card.querySelector('modal-opener button');
        if (openerBtn) {
          openerBtn.click();
        }
      }
    });

    // Shipping selection change listener
    sectionEl.addEventListener('change', function(e) {
      if (e.target.name === 'bundle-shipping') {
        selectedShipping = e.target.value;
        renderBuilder();
      }
    });

    // Submit Custom Package - Guaranteed Atomic Reconcile, Apply Discount & Open Cart
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (bundleItems.length < 1) return;

        submitBtn.classList.add('loading');
        submitBtn.setAttribute('disabled', 'disabled');

        if (syncDebounceTimer) clearTimeout(syncDebounceTimer);

        var count = bundleItems.length;
        var discountCode = count >= 4 ? 'BUNDLE15' : (count === 3 ? 'BUNDLE10' : '');

        // 1. Force flush cart sync immediately so Shopify cart is 100% matched to bundleItems
        reconcileCartWithShopify()
          .then(function() {
            // 2. Apply bundle discount if applicable
            if (discountCode) {
              return fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart', {
                method: 'GET',
                credentials: 'same-origin'
              });
            }
            return Promise.resolve();
          })
          .then(function() {
            // 3. Open drawer if present, else redirect to /cart
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              var cartSectionsUrl = rootUrl + (rootUrl.endsWith('/') ? '' : '/') + '?sections=cart-drawer,cart-icon-bubble';
              return Promise.all([
                fetch(cartSectionsUrl, {
                  headers: { 'Accept': 'application/json' },
                  credentials: 'same-origin'
                }).then(function(res) { return res.json(); }),
                fetch('/cart.js', {
                  headers: { 'Accept': 'application/json' },
                  credentials: 'same-origin'
                }).then(function(res) { return res.json(); })
              ])
              .then(function(results) {
                var sectionsData = results[0];
                var freshCart = results[1];

                submitBtn.classList.remove('loading');
                submitBtn.removeAttribute('disabled');

                if (sectionsData && (sectionsData['cart-drawer'] || (sectionsData.sections && sectionsData.sections['cart-drawer']))) {
                  var payload = sectionsData.sections ? sectionsData : { sections: sectionsData };
                  payload.item_count = freshCart.item_count;
                  payload.total_price = freshCart.total_price;
                  payload.original_total_price = freshCart.original_total_price;
                  payload.total_discount = freshCart.total_discount;
                  payload.items = freshCart.items;
                  if (typeof cartDrawer.renderContents === 'function') {
                    cartDrawer.renderContents(payload, true);
                  } else {
                    cartDrawer.open();
                  }
                } else {
                  cartDrawer.open();
                }
              });
            } else {
              window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            }
          })
          .catch(function(err) {
            console.error('Error proceeding with bundle:', err);
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('disabled');
            window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          });
      });
    }

    // Flush pending sync if user clicks the header cart icon directly
    var headerCartLink = document.getElementById('cart-icon-bubble');
    if (headerCartLink) {
      headerCartLink.addEventListener('click', function() {
        if (isSyncing || syncPending || syncDebounceTimer) {
          if (syncDebounceTimer) clearTimeout(syncDebounceTimer);
          reconcileCartWithShopify();
        }
      }, true);
    }

    // Flush sync on beforeunload
    window.addEventListener('beforeunload', function() {
      if (syncDebounceTimer) {
        clearTimeout(syncDebounceTimer);
        reconcileCartWithShopify();
      }
    });

    // Initial render & sync from Shopify Cart
    renderBuilder();
    syncFromCart(false);

    // Live cart sync listeners (only when not locally mutating)
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event && event.source === 'custom-package-builder') return;
        syncFromCart(false);
      });
    }
    window.addEventListener('focus', function() {
      syncFromCart(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomPackageBuilder);
  } else {
    initCustomPackageBuilder();
  }
  document.addEventListener('shopify:section:load', initCustomPackageBuilder);
})();